import apiClient from './api';
import type { VolunteerFormData } from '@/types';

export interface VolunteerSignupDTO extends VolunteerFormData {}

export interface VolunteerResponse {
  id: string;
  status: 'pending' | 'confirmed' | 'contacted';
  createdAt: string;
  message?: string;
}

export const volunteerService = {
  /**
   * Register a new volunteer
   * @param data - Volunteer registration form data
   * @returns Registration confirmation with volunteer ID
   */
  async signup(data: VolunteerSignupDTO): Promise<VolunteerResponse> {
    try {
      console.log('Submitting volunteer signup with data:', data);
      const response = await apiClient.post<VolunteerResponse>('/volunteers/register', data);
      return response.data;
    } catch (error) {
      console.error('Volunteer signup error:', error);
      throw error;
    }
  },
};